const ListItemText = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      margin: 0,
      color: theme.palette.text.primary,
    }),
    primary: ({ theme }) => ({
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.body1.fontWeight,
      whiteSpace: "nowrap",
    }),
  },
};

export default ListItemText;
